import { render, staticRenderFns } from "./NumberOfNearest.vue?vue&type=template&id=4ebf5fee"
import script from "./NumberOfNearest.vue?vue&type=script&lang=js"
export * from "./NumberOfNearest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports